import { IMAGE_BASE_URL, LANGUAGES } from "@/constants/common"

import { ChipGroup } from "@/components/Chip/ChipGroup"
import { TTrack } from "@/features/session/types"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { device_px } from "@/styles/variable"
import { forwardRef } from "react"
import { useTranslation } from "react-i18next"
import { SessionTracksContainer } from "./styles"

interface ISessionTracksProps {
  tracks?: TTrack[]
  onChange?: (value: number[]) => void
  value?: number[]
}

export const SessionTracks = forwardRef<HTMLDivElement, ISessionTracksProps>(
  ({ tracks, value, onChange, ...props }, ref) => {
    const {
      i18n: { language }
    } = useTranslation()

    const isTabletOrMobile = useMediaQuery(`(max-width: ${device_px.MAX_1279})`)

    return (
      <SessionTracksContainer ref={ref} {...props}>
        <ChipGroup
          options={tracks?.map(track => ({
            value: track.id,
            iconSrc: track.iconImage
              ? IMAGE_BASE_URL + encodeURIComponent(track.iconImage)
              : undefined,
            iconAlt: track.nameKo,
            label: language === LANGUAGES.en ? track.nameEn : track.nameKo,
            backgroundColor: track.backgroundColor,
            textColor: track.textColor
          }))}
          onChange={onChange}
          value={value}
          size={isTabletOrMobile ? "medium" : "large"}
        />
      </SessionTracksContainer>
    )
  }
)
